import { render, staticRenderFns } from "./ReportProblem.vue?vue&type=template&id=5d879368&scoped=true&"
import script from "./ReportProblem.vue?vue&type=script&lang=ts&"
export * from "./ReportProblem.vue?vue&type=script&lang=ts&"
import style0 from "./ReportProblem.vue?vue&type=style&index=0&id=5d879368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d879368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d879368', component.options)
    } else {
      api.reload('5d879368', component.options)
    }
    module.hot.accept("./ReportProblem.vue?vue&type=template&id=5d879368&scoped=true&", function () {
      api.rerender('5d879368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/lessons/lesson/ReportProblem.vue"
export default component.exports